import { useTooltipRebuild } from "hooks/useTooltipRebuild";
import React from "react";
import { useSelector } from "react-redux";
import { Icon } from "rhombus-react";
import { getAdvertiserAutoClassificationEnabled, getRemainingCredits } from "selectors/Intelligence";

import "./AdvertiserCredits.css";

const formatter = new Intl.NumberFormat("en-US", {
	notation: "compact",
	maximumFractionDigits: 1,
});

export default function AdvertiserCredits(){
	const remainingCredits = useSelector(getRemainingCredits);
	const isAdvertiserClassificationEnabled = useSelector(getAdvertiserAutoClassificationEnabled);
	const formattedCredits = formatter.format(remainingCredits);
	const isLibraryClassificationEnabled = useSelector(state => state.libraryProperties?.isClassificationEnabled);

	useTooltipRebuild([]);

	if(!isAdvertiserClassificationEnabled || !isLibraryClassificationEnabled){
		return null;
	}

	return (
		<div
			className="advertiser-credits"
			data-tip="Auto-classification credits available.  Each credit can be used to classify 1 creative or 1 version."
		>
			<Icon name="fas fa-tags" />
			{formattedCredits} {remainingCredits === 1 ? "Credit" : "Credits"}
		</div>
	);
}

AdvertiserCredits.displayName = "AdvertiserCredits";
